<div
	[formGroup]="group"
	[matTooltip]="disabledProject ? ('errors.project.completed' | translate) : null"
	[matTooltipOptions]="{ followCursor: 'horizontal' }"
	[ngClass]="{
    'mat-bg-3': disabledProject,
    'bg-accent-1': (isEditing | async) && canEdit$.value && !group.errors?.nochange && !disabled && !isLoading,
  }"
	class="-mx-16px flex h-14 flex-row items-center justify-start gap-2 px-16px"
>
	<div
		*ngIf="isLoading"
		class="flex w-6 flex-col items-center justify-center"
	>
		<mat-progress-spinner
			[diameter]="16"
			[mode]="'indeterminate'"
			[strokeWidth]="2"
			color="primary"
		></mat-progress-spinner>
	</div>
	@if (!bulkSelectionCheckboxDisabled) {
	<div
		[matTooltip]="'utils.disabled' | translate"
		[matTooltipDisabled]="!bulkSelectionCheckboxDisabled"
		class="inline-flex size-10 flex-shrink-0 items-center justify-center"
	>
		<mat-checkbox
			(change)="onCheckedChange()"
			[checked]="checked"
			[disabled]="bulkSelectionCheckboxDisabled"
			color="primary"
		></mat-checkbox>
	</div>
	} @else {
	<div
		[matTooltip]="'utils.disabled' | translate"
		class="inline-flex size-10 flex-shrink-0 cursor-default items-center justify-center"
	>
		<span
			aria-hidden="true"
			class="inline-flex size-4 shrink-0 rounded-sm border-2 border-dashed border-gray-400/90 bg-gray-100/25 select-none dark:border-gray-600/70 dark:bg-gray-900/30"
			role="presentation"
		></span>
	</div>
	}
	<div class="flex-auto">
		<input
			[placeholder]="
				group.controls.name.disabled && !groupValue.name?.trim() ? '' : ('time.add-name' | translate)
			"
			class="flex-grow cursor-pointer border-0 bg-transparent px-2.5 py-3 opacity-80 !outline-none wflex-[1_0_300px] focus:cursor-text focus:opacity-100 disabled:cursor-default disabled:opacity-80 disabled:select-none"
			formControlName="name"
			type="text"
		>
	</div>
	<div class="justify ml-auto flex flex-row items-center gap-2">
		<div
			(click.prevent)="onOpenUserPicker()"
			(keyup.enter)="$event.preventDefault(); onOpenUserPicker()"
			[ngClass]="{
        'mat-bg-2 mat-bg-3-hover cursor-pointer select-none rounded': isAdmin$.value && !disabled,
      }"
			class="flex h-10 flex-row items-center justify-start gap-2 px-2.5 py-1 wflex-[0_0_200px] lg:wflex-[0_0_240px] xl:wflex-[0_0_280px]"
			tabindex="1"
		>
			<div class="size-6 flex-shrink-0">
				<app-user-avatar
					[userId]="groupValue.user?.id ?? 'default'"
					class="rounded-full"
					size="100%"
				></app-user-avatar>
			</div>
			<div class="truncate"><span>{{ groupValue.user?.name || '' }}</span></div>
		</div>
		<div
			*ngIf="groupValue.project as project; else noProject"
			class="flex flex-row items-center justify-start wflex-[0_0_220px]"
		>
			<div
				(click)="$event.preventDefault(); onOpenProjectPicker()"
				(keyup.enter)="$event.preventDefault(); onOpenProjectPicker()"
				[disabled]="disabled || !canEdit$.value"
				[matTooltipDisabled]="disabledProject"
				[matTooltipOptions]="{ delay: [500, 0] }"
				[matTooltipTemplate]="projectPickerTooltip"
				[matTooltipTemplateContext]="projectTooltipData$ | async"
				[ngClass]="{
          'mat-bg-2 mat-bg-3-hover cursor-pointer select-none rounded': !disabled,
        }"
				class="flex flex-auto flex-col truncate px-2.5 h-10 justify-center"
				matTooltip
				tabindex="1"
			>
				<div class="flex items-center space-x-1">
					<div
						[style.backgroundColor]="color"
						*ngIf="this.getProjectColor(project.id) as color"
						class="project-color-dot -mt-px"
					></div>
					<span
						*ngIf="project | defaultEntityTranslate: 'project' : 'project.none' as projectName"
						class="truncate"
					>
						{{ projectName }}</span
					>
				</div>
				<span class="mat-hint flex-shrink-0 truncate text-sm">{{
					groupValue.task?.name || ('task.none' | translate)
				}}</span>
			</div>
		</div>
		<div class="flex items-center wflex-[0_0_180px]">
			<button
				(click)="onToggleBillable()"
				[disabled]="disabled || !canEdit$.value"
				class="mat-bg-2 mat-bg-3-hover size-10 flex-center flex-shrink-0 rounded border-0 outline-none"
			>
				<mat-icon
					[class.mat-accent]="groupValue.billable"
					inline
				>
					attach_money
				</mat-icon>
			</button>
		</div>
		<div class="flex items-center wflex-[0_0_80px]">
			<button
				(click)="onOpenTagsDialog()"
				[disabled]="disabled || !canEdit$.value"
				[matTooltipDisabled]="!(tagTooltipData$ | async)?.tags?.length"
				[matTooltipOptions]="{ delay: [500, 0] }"
				[matTooltipTemplate]="tagPickerTooltip"
				[matTooltipTemplateContext]="tagTooltipData$ | async"
				class="mat-bg-2 mat-bg-3-hover size-10 flex-center flex-shrink-0 rounded border-0 outline-none"
				matTooltip
			>
				<mat-icon
					[class.mat-accent]="groupValue.tags?.length > 0"
					class="rotate-45"
					inline
				>
					label
				</mat-icon>
			</button>
		</div>
		<div
			(click)="!disabled && canEdit$.value && dateClick.emit($event)"
			[ngClass]="{'cursor-pointer':!disabled && canEdit$.value}"
			class="select-none wflex-[0_0_100px]"
		>
			<ng-container *ngIf="entry$duration | async as duration">
				<span [class.mat-hint]="duration.hours === 0">{{ duration.hours | padLeft: 2 : 0 }}</span>
				<span [class.mat-hint]="duration.minutes === 0 || duration.hours === 0">:</span>
				<span [class.mat-hint]="duration.minutes === 0">{{ duration.minutes | padLeft: 2 : 0 }}</span>
			</ng-container>
		</div>
		<div
			*ngIf="showAmount"
			class="select-none truncate wflex-[0_0_100px]"
		>
			{{ entry.amount || 0 | customCurrency }}
		</div>
		<div
			(click)="onDateClick($event)"
			[ngClass]="{
        'flex h-10 justify-center': time.inputMode === 'duration',
		'cursor-pointer': !disabled && canEdit$.value
      }"
			*ngIf="time$ | async as time"
			class="mat-bg-2-hover flex select-none flex-col rounded px-1.5 py-2 wflex-[0_0_200px]"
		>
			<ng-container *ngIf="!time.inputMode || time.inputMode === 'range'; else dateDisplay">
				<div class="mb-0.5 flex items-center space-x-0.5 leading-none">
					<span class="text-sm leading-none">{{ time.viewStart ?? time.start | formatDate: 'time' }}</span>
					<ng-container
						*ngTemplateOutlet="time.end ? normalEndView : ongoingEndView; context: { time: time.end, timeWithTz: time.viewEnd }"
					></ng-container>
				</div>
			</ng-container>
			<ng-template #dateDisplay>
				<div class="mb-0.5 flex items-center space-x-0.5 leading-none">
					<span class="text-sm leading-none">{{ time.viewStart ?? time.start | dfnsFormat: 'EEEE' }}</span>
				</div>
			</ng-template>
			<div class="flex flex-col space-y-0.5">
				<div class="mat-hint text-sm leading-none">{{ time.viewStart ?? time.start | formatDate }}</div>
				<div
					*ngIf="time.tz as tz"
					class="flex items-center space-x-0.5"
				>
					<div
						*ngIf="tz.value !== undefined"
						class="mat-hint text-sm leading-none"
					>
						(GMT+{{ tz.offset / 60 }})
					</div>
					<div
						*ngIf="time.timeZone"
						class="mat-hint text-sm leading-none"
					>
						{{ time.timeZone }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template
	#normalEndView
	let-end="time"
	let-tzEnd="timeWithTz"
>
	<span>-</span>
	<span class="text-sm leading-none">{{ tzEnd ?? end | formatDate: 'time' }}</span>
</ng-template>
<ng-template
	#ongoingEndView
	let-time="time"
>
	<span>-</span>
	<span class="text-sm leading-none text-red-500">Now</span>
</ng-template>
<ng-template #noProject>
	<div
		(click)="onOpenProjectPicker()"
		[ngClass]="{ 'cursor-pointer': !disabled && canEdit$.value }"
		class="h-6 wflex-[0_0_220px]"
	></div>
</ng-template>
<ng-template #noGroup> <div class="wflex-[0_0_220px]"></div> </ng-template>
<ng-template
	#projectPickerTooltip
	let-project="project"
	let-tags="tags"
	let-task="task"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="font-semibold">
				{{ project?.client | defaultEntityTranslate: 'client' : 'client.none' : ('client.none' | translate) }}
			</div>
		</div>
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				project.single
			</h3>
			<div class="font-semibold">{{ project | defaultEntityTranslate: 'project' : 'project.none' }}</div>
		</div>
		<div
			*ngIf="(project | projectProxy)?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
		<ng-container *ngIf="tags && tags.length > 0">
			<div class="space-y-1">
				<h3
					class="mat-hint text-sm italic"
					translate
				>
					tag.plural
				</h3>
				<div class="flex flex-wrap gap-2">
					<div
						*ngFor="let item of tags; trackBy: trackId"
						class="mbg-card pointer-events-none h-6 cursor-default select-none truncate rounded-full px-2.5 text-base leading-6"
					>
						{{ item.name }}
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>
<ng-template
	#tagPickerTooltip
	let-tags="tags"
>
	<div class="flex flex-col gap-1.5">
		<div
			*ngFor="let item of tags; trackBy: trackId"
			class="flex items-center gap-2"
		>
			<span
				[style.backgroundColor]="tagDisplayColor(item)"
				class="project-color-dot flex-shrink-0 !cursor-default !m-0"
			></span>
			<span>{{ item.name }}</span>
		</div>
	</div>
</ng-template>
